import { WarrantyLogModel } from '../../../model/types';
import styles from './styles.module.scss';
import { WarLogStatusesEnum } from 'api-new/generated';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { FC } from 'react';
import { formatDateSafe } from 'utils/formats';

const WA_STATUS_UI_MAP: Record<
  WarLogStatusesEnum,
  {
    className: string;
    icon?: React.ReactNode;
    text: string;
  }
> = {
  [WarLogStatusesEnum.CorrectionRequired]: {
    className: '',
    text: 'Correction Required'
  },
  [WarLogStatusesEnum.Pending]: {
    className: styles.yellowBlock,
    text: 'Pending'
  },
  [WarLogStatusesEnum.WorkNotCompleted]: {
    className: styles.redBlock,
    text: 'WA Check',
    icon: <InlineSvg path="/media/icons/custom/user-edit.svg" />
  },
  [WarLogStatusesEnum.InvoicedAndSubmitted]: {
    className: clsx(styles.greenBlock, styles.invoicedStatus),
    text: 'Invoiced & Submitted'
  },
  [WarLogStatusesEnum.ATPPending]: {
    className: '',
    text: 'ATP Pending'
  },
  [WarLogStatusesEnum.ReadyToWork]: {
    className: '',
    text: 'Ready To Work'
  },
  [WarLogStatusesEnum.Rejected]: {
    className: '',
    text: 'Rejected'
  }
};

export const WaStatusCell: FC<{ data: WarrantyLogModel }> = ({ data }) => {
  const status = data?.waStatus;
  const ui =
    typeof status === 'number' && status in WA_STATUS_UI_MAP
      ? WA_STATUS_UI_MAP[status as WarLogStatusesEnum]
      : undefined;

  return (
    <div>
      {Boolean(data?.waUserName) && <div className={styles.textBold}>{data?.waUserName}</div>}

      {ui && (
        <div className="py-1">
          <span className={ui.className}>
            {ui.icon} {ui.text}
          </span>
        </div>
      )}

      <div>{formatDateSafe(data.waDate, 'DD/MM/YYYY HH:mm', '-')}</div>
    </div>
  );
};
